module.exports = __webpack_public_path__ + "static/img/record_icon.9b53f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/record_icon.png
// module id = AbVi
// module chunks = 4